// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__qElTq","label":"SetPasswdForm_label__3BY-a"};